<template>
<div class="container-fluid" >

 <div class="card border-success">
   
  <h4 class="card-header text-white bg-primary"><i class="fas fa-cash-register mr-2" aria-hidden="true"></i>ANALISI KPI RETAIL</h4>

 <div  class="card-body"> 

  <div class="row">
  <div class="col-2"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-black">


  <form name="movementSearch" v-on:submit.prevent="submit()">

  

    <div class="form-group">  
      <store-select  required v-bind:isActive="items.length==0" @update="setStoreId"></store-select>
    </div>

    
    <div class="form-group">
      <label for="date_doc"><strong>DA DATA  </strong></label>
        <input :disabled="items.length>0" required v-model="data1" type="date" class="form-control bold" placeholder="" >        
    </div>
    <div class="form-group">
      <label for="date_doc"><strong>A DATA </strong></label>
        <input :disabled="items.length>0" required v-model="data2" type="date" class="form-control bold" placeholder="" >        
    </div>
    
           
   <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
    <i class="far fa-play-circle mr-2"></i>
     ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
     </button>           

    <button  @click="items=[],row_total=[]" type="button"   class="btn btn-secondary ">
      <i style="color:yellow" class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>           
  </form>

  
  
 </div>
</div>
 </div>


<div class="col-10">
     <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table class="table table table-sm table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        
        <th scope="col">DATA</th>
        <th class="text-right" scope="col">TOTALE</th>        
        <th class="text-right" scope="col">SCONTRINI</th> 
        <th class="text-right" scope="col">ARTICOLI</th> 
        <th class="text-right" scope="col">UPT</th>        
        <th class="text-right" scope="col">AVT</th>        
        
      </tr>
    </thead>
    <tbody>

      <tr  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">
        
        <td>{{item.create_at}} </td>
        
        <td class="text-right">{{fmt1(item.total)}}</td>
        <td class="text-right">{{item.tickets}}</td>
        <td class="text-right">{{item.items}}</td>
        <td class="text-right">{{item.upt}} </td>
        <td class="text-right">{{fmt1(item.avt)}} </td>
               
      </tr> 
    </tbody>
    <tfoot>
        <tr  :style="{backgroundColor: item.row_type == 3 ? '#FFFFE0':'white', color: item.row_type==2  ? 'blue' : 'black',fontSize: item.row_type == 3 ? '20px':'15px',fontWeight:item.row_type == 3 ? 'bold':'normal' }"  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        
          <td>TOTALE</td>
          <td class="text-right">{{fmt1(item.total)}}</td>   
          <td class="text-right">{{item.tickets}}</td>
          <td class="text-right">{{item.items}}</td>     
          <td class="text-right">{{item.upt}}</td>
          <td class="text-right">{{fmt1(item.avt)}}</td>
        
        </tr>   
    </tfoot>    
  </table>

</div>

</div>  


  </div>

  <alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  
  
 

</div>
</div>
</div>


</template>
<script>

import api               from "@/api"
import alertBox          from '@/components/common/AlertBox.vue';
import storeSelect       from '@/components/common/StoreSelect.vue'

export default {
  components: {alertBox,storeSelect},
  data() {
    return {
       
      storeId         : null,
      data1           : null,
      data2           : new Date().toISOString().slice(0, 10),
      alert           : false, 
      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : []
      
    };
  },

  computed :{
   
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {},
  methods: {
    fmt1(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },  
    setStoreId(storeId)
    {
        this.storeId = storeId
    },  
    
    
    submit() 
    {
     this.getData()
    },  
    
    
    async getData() {
      
      this.row_total = []
      this.items = []
     
      

      this.msg.title = ''
      var sp = {'sp' : 'spStorePaymentsList_KPI'}      
      var data  = {

          'storeId' :this.storeId,'data1':this.data1,'data2':this.data2
      }
     
      var json  = Object.assign(data, sp)

      this.spinner = true

      await api.post(json).then(res => {
        
          if(res.status==200)
            {
              this.items = res.data.recordsets[0].filter(item=>item.row_type==0)
              this.row_total = res.data.recordsets[0].filter(item=>item.row_type==1)
          
              if(this.items.length==0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
        
          else
          {

            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      




    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>